<script setup lang="ts">
import { WEB_APP_URL } from '~/constants/website'

useDefaultMeta({
  title: 'Aplikasi Kirim Paket COD Terbaik #1 Indonesia | KiriminAja',
  description:
    'Kirim paket ke seluruh Indonesia dengan pengiriman reguler KiriminAja! Ekspedisi terlengkap, bisa COD, &amp; tanpa minimum jumlah kiriman. Kirim sekarang!',
  robots: 'index, follow'
})

const faqs = [
  {
    question: 'Apa yang dimaksud dengan laporan pengiriman di KiriminAja?',
    answer:
      '<p>Laporan pengiriman adalah fitur yang menyediakan data terperinci tentang riwayat pengiriman, termasuk jumlah paket, area tujuan, dan status pengiriman dalam format yang mudah dipahami seperti grafik atau file Excel/CSV.</p>'
  },
  {
    question: 'Bagaimana cara mengunduh data pengiriman?',
    answer:
      '<p>Kamu dapat mengunduh data pengiriman melalui dashboard KiriminAja. Pilih opsi unduhan dalam format Excel atau CSV untuk mengakses laporan riwayat pengiriman.</p>'
  },
  {
    question: 'Apakah KiriminAja menyediakan statistik area pengiriman?',
    answer:
      '<p>Ya, KiriminAja menyediakan statistik area pengiriman yang membantu memantau tren pengiriman berdasarkan jumlah paket dan lokasi tujuan.</p>'
  },
  {
    question: 'Apa saja laporan keuangan yang tersedia?',
    answer:
      '<p>KiriminAja menyediakan laporan saldo masuk dan keluar, estimasi dana paket COD yang masih dalam proses, serta riwayat penyesuaian ongkir untuk transparansi keuangan bisnis.</p>'
  },
  {
    question: 'Apakah data pengiriman dapat diakses secara real-time?',
    answer:
      '<p>Ya, laporan dan statistik pengiriman di KiriminAja dapat diakses kapan saja melalui aplikasi atau dashboard, sehingga memudahkan pengelolaan data secara real-time.</p>'
  },
  {
    question: 'Apa manfaat grafik data informatif dari KiriminAja?',
    answer:
      '<p>Grafik data mempermudah analisis performa pengiriman dengan visualisasi tren, sehingga membantu dalam pengambilan keputusan bisnis yang lebih strategis.</p>'
  },
  {
    question: 'Apakah saya bisa memantau saldo aktif untuk pengiriman COD?',
    answer:
      '<p>KiriminAja memberikan detail tentang saldo aktif dan estimasi dana yang akan diterima dari paket COD yang sedang dalam proses pengiriman.</p>'
  },
  {
    question: 'Apa itu riwayat penyesuaian ongkir?',
    answer:
      '<p>Riwayat penyesuaian ongkir mencatat kelebihan atau kekurangan ongkos kirim yang memengaruhi saldo aktif Anda, memastikan laporan keuangan tetap transparan.</p>'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Kelola Pengiriman Bisnis dengan Laporan yang Akurat"
      sub-title="Laporan & Statistik Pengiriman"
      description="Semua data pengiriman hingga keuangan tersedia dalam satu platform yang mudah diakses kapan saja."
      hero-image="/images/batch-2/report-welcome.avif"
      button-label="Daftar Gratis"
      :button-link="$utm.utmUrl(WEB_APP_URL)"
    />
    <SolusiLaporanBenefit />
    <SolusiLaporanDataPengiriman />
    <SolusiLaporanTransparan />
    <FaqBase :faqs="faqs" />
    <CtaSection />
  </div>
</template>
